import PT from 'prop-types'
import React from 'react'
import './index.scss'

const Layout = props => {
  const {children, className} = props
  return <div className={`bridgePageContainer ${className}`}>{children}</div>
}

export default Layout
Layout.defaultProps = {
  className: '',
}

Layout.propTypes = {
  children: PT.node.isRequired,
  className: PT.string,
}
